export const URL_BASE_PERIMETERS = 'perimeters'
export const URL_BASE_PATTERNS = 'patterns/'
